import camelCase from 'lodash/camelCase';
import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import pickBy from 'lodash/pickBy';
import { resolutionTypeMap } from '../model/ResolutionType';
import { Vehicle, VehicleRaw } from '../model/Vehicle';

export const VehicleDecoder = (rawVehicle: VehicleRaw): Vehicle => {
  const {
    id,
    fin,
    vin,
    brand,
    series,
    mileage,
    category,
    imageUrl,
    odometer,
    modelYear,
    driveUnit,
    modelName,
    contracts,
    className,
    mileageUnit,
    resolutionType,
    serviceCarePlan,
    preferredDealer,
    registrationPlate,
  } = rawVehicle;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const vehicle: Record<string, any> = {
    id: id ?? get(rawVehicle, camelCase(resolutionType)),
    fin,
    vin,
    brand,
    series: series?.toString(), // Convert series to string
    category,
    imageUrl,
    modelYear,
    contracts,
    className,
    driveUnit,
    name: modelName,
    serviceCarePlan,
    originalServiceCarePlan: serviceCarePlan,
    ...(mileage ? { mileage, mileageUnit } : {}),
    ...(registrationPlate ? { licensePlate: registrationPlate } : {}),
    ...(preferredDealer ? { preferredDealerId: preferredDealer?.id } : {}),
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    ...(resolutionType ? { resolutionType: get(resolutionTypeMap, resolutionType) } : {}),
    ...(odometer?.distance ? { mileage: `${odometer.distance}`, mileageUnit: odometer.unit } : {}),
  };
  return pickBy(vehicle, (value) => !isUndefined(value));
};
